import { cloneDeep as _cloneDeep } from 'lodash';
export default (p) => {
    const polygon = _cloneDeep(p);
    // 计算向量叉乘
    const crossMul = function (v1, v2) {
        return v1.x * v2.y - v1.y * v2.x;
    };
    // 判断两条线段是否相交
    const checkCross = function (p1, p2, p3, p4) {
        let v1 = { x: p1.x - p3.x, y: p1.y - p3.y };
        let v2 = { x: p2.x - p3.x, y: p2.y - p3.y };
        let v3 = { x: p4.x - p3.x, y: p4.y - p3.y };
        const v = crossMul(v1, v3) * crossMul(v2, v3);
        v1 = { x: p3.x - p1.x, y: p3.y - p1.y };
        v2 = { x: p4.x - p1.x, y: p4.y - p1.y };
        v3 = { x: p2.x - p1.x, y: p2.y - p1.y };
        return !!(v <= 0 && crossMul(v1, v3) * crossMul(v2, v3) <= 0);
    };
    let pointer = 0;
    const loop = (lines) => {
        let isCross = false;
        try {
            if (lines.length > 3) {
                for (let i = 2; i < lines.length - 1; i++) {
                    if (pointer + i > lines.length - 1) {
                        // console.log(pointer, pointer + i, '相邻,排除');
                        continue;
                    }
                    if (checkCross(lines[pointer].p1, lines[pointer].p2, lines[pointer + i].p1, lines[pointer + i].p2)) {
                        isCross = true;
                        // console.log(pointer, pointer + i, '交叉');
                        return isCross;
                    }
                    // console.log(pointer, pointer + i, '未交叉');
                }
                pointer++;
                // console.log('lines.length', lines.length);
                // console.log(pointer, pointer < lines.length - 2);
                if (!isCross && pointer < lines.length - 2) {
                    // 未交叉
                    return loop(lines);
                }
                return isCross;
            }
        }
        catch (error) {
            /* tslint:disable */
            console.log('error', '\n', error);
            /* tslint:enable */
        }
        return isCross;
    };
    if (!Array.isArray(polygon)) {
        return false;
    }
    polygon.shift();
    const lines = polygon.map((xy, i) => {
        if (i === 0) {
            return {
                p1: {
                    x: polygon[polygon.length - 1].x,
                    y: polygon[polygon.length - 1].y,
                },
                p2: { x: xy.x, y: xy.y },
            };
        }
        return {
            p1: { x: polygon[i - 1].x, y: polygon[i - 1].y },
            p2: { x: xy.x, y: xy.y },
        };
    });
    return loop(lines);
};
